import { useCallback, useEffect, useState } from 'react';

import useServerPagination from '@/hooks/useServerPagination';
import { initializeHttpProvider } from '@/providers/HttpProvider/initializeHttpProvider';

import type {
  IReqInvoicing,
  IResInvoicingData,
  IResInvoicingError,
  IResInvoicingOK,
} from '@/types/parcel/userData/invoices.interface';

interface InvoicesState {
  data: IResInvoicingData | null;
  loading: boolean;
  error: IResInvoicingError | null;
}

const initialStateInvoices: InvoicesState = {
  data: null,
  loading: false,
  error: null,
};

const useInvoicesSection = () => {
  const [editProfile, setEditProfile] = useState(false);
  const [chargeDrawer, setChargeDrawer] = useState(false);
  const [invoices, setInvoices] = useState<InvoicesState>(initialStateInvoices);
  const [dateFilters, setDateFilters] = useState<{ startDate?: string; endDate?: string }>({});
  const pagination = useServerPagination();

  const getInvoices = useCallback(
    async (params?: Partial<IReqInvoicing>) => {
      const http = initializeHttpProvider();
      try {
        setInvoices((prev) => ({ ...prev, loading: true }));

        const response = await http.userData.invoices({
          page: pagination.filters.page ? pagination.filters.page + 1 : 1, // DataGrid usa 0-based, API usa 1-based
          pageSize: pagination.filters.page_size,
          ...dateFilters,
          ...params,
        });

        const data = (response as IResInvoicingOK).data;

        setInvoices({ data, loading: false, error: null });
      } catch (error: any) {
        setInvoices((prev) => ({
          data: prev.data,
          loading: false,
          error: error.response as IResInvoicingError,
        }));
      }
    },
    [pagination.filters.page, pagination.filters.page_size, dateFilters],
  );

  const handleDateChange = useCallback((filterName: string, value: string) => {
    setDateFilters((prev) => ({ ...prev, [filterName]: value || undefined }));
  }, []);

  useEffect(() => {
    void getInvoices();
  }, [pagination.filters.page, pagination.filters.page_size, dateFilters]);

  return {
    setEditProfile,
    editProfile,
    setChargeDrawer,
    chargeDrawer,
    invoices,
    pagination,
    getInvoices,
    handleDateChange,
  };
};

export default useInvoicesSection;
